var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paper_texture_background_cardboard_pattern_page_blank_white_letter_canvas"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,11a1,1,0,0,0-.28-.71l-8-8A1,1,0,0,0,17,2H9A3,3,0,0,0,6,5V27a3,3,0,0,0,3,3H23a3,3,0,0,0,3-3V11ZM18,5.41,22.59,10H19a1,1,0,0,1-1-1ZM23,28H9a1,1,0,0,1-1-1V5A1,1,0,0,1,9,4h7V9a3,3,0,0,0,3,3h5V27A1,1,0,0,1,23,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,16h4a1,1,0,0,0,0-2H11a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,18H11a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,22H11a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlank);
export default __webpack_public_path__ + "static/media/blank.3524875a57e72e53f86a68980da2310a.svg";
export { ForwardRef as ReactComponent };